import {Injectable} from '@angular/core';
import {LanguageQuery, LanguagesQuery, MesApiService} from 'common-shared';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends MesApiService {
  constructor(public query: LanguagesQuery) {
    super('language');
  }

  getAll$: Observable<LanguageQuery[]> = this.query.selectAll();

}
